module.exports = __webpack_public_path__ + "media/fonts/BasisGrotesquePro-MediumItalic-dbdb816227cddcad72c8c38d003a9c44.woff";